import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import UsersPage from "@/pages/UsersPage";
import RolesPage from "@/pages/RolesPage";
import TeamsPage from "@/pages/TeamsPage";
import ChannelsPage from "@/pages/ChannelsPage";
import CustomersPage from "@/pages/CustomersPage";
import OrdersPage from "@/pages/OrdersPage";
import OrderDetailPage from "@/pages/OrderDetailPage";
import CreateOrderPage from "@/pages/CreateOrderPage";
import SKUsPage from "@/pages/SKUsPage";
import CataloguePage from "@/pages/CataloguePage";
import CatalogueApprovalsPage from "@/pages/CatalogueApprovalsPage";
import ExternalShipOrdersPage from "@/pages/ExternalShipOrdersPage";
import AdminCategoriesPage from "@/pages/AdminCategoriesPage";
import AdminCustomerTypesPage from "@/pages/AdminCustomerTypesPage";
import AdminSettingsPage from "@/pages/AdminSettingsPage";
import DataScriptsPage from "@/pages/DataScriptsPage";
import ReportsPage from "@/pages/ReportsPage";
import WarehousesPage from "@/pages/WarehousesPage";
import InventoryPage from "@/pages/InventoryPage";
import SecurityDashboardPage from "@/pages/SecurityDashboardPage";
import SSInventoryPage from "@/pages/SSInventoryPage";
import SSOpeningStockPage from "@/pages/SSOpeningStockPage";
import SSRecordDeliveryPage from "@/pages/SSRecordDeliveryPage";
import SSRecordOutflowPage from "@/pages/SSRecordOutflowPage";
import SSResetStockPage from "@/pages/SSResetStockPage";
import SSFacilityMappingPage from "@/pages/SSFacilityMappingPage";
import PlatformSkuMappingPage from "@/pages/PlatformSkuMappingPage";
import SSInTransitPage from "@/pages/SSInTransitPage";
import ProfilePage from "@/pages/ProfilePage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import RTOListPage from "@/pages/RTOListPage";
import RTODetailPage from "@/pages/RTODetailPage";
import ProformaInvoicesPage from "@/pages/ProformaInvoicesPage";
import RTOStockPage from "@/pages/RTOStockPage";
import DamagedStockPage from "@/pages/DamagedStockPage";
import CreditNotesPage from "@/pages/CreditNotesPage";
import POInboxPage from "@/pages/POInboxPage";
import QcomHealthPage from "@/pages/QcomHealthPage";
import QcomSLAPerformancePage from "@/pages/QcomSLAPerformancePage";
import SalesTargetsPage from "@/pages/SalesTargetsPage";
import PnLAuditPage from "@/pages/PnLAuditPage";
import StockOnHoldPage from "@/pages/StockOnHoldPage";
import QcomSSDetailPage from "@/pages/QcomSSDetailPage";
import BlinkitChecksPage from "@/pages/BlinkitChecksPage";
import PlatformInvoicesPage from "@/pages/PlatformInvoicesPage";
import SorAccountsPage from "@/pages/SorAccountsPage";
import RefundsPage from "@/pages/RefundsPage";
import PODReportPage from "@/pages/PODReportPage";
import MigrateInvoiceDatesPage from "@/pages/MigrateInvoiceDatesPage";
import ChannelBackfillPage from "@/pages/ChannelBackfillPage";
import DataQualityPage from "@/pages/DataQualityPage";
import ReceivablesPage from "@/pages/ReceivablesPage";
import FreightUploadPage from "@/pages/FreightUploadPage";
import PulsePage from "@/pages/PulsePage";
import DemandPlanningPage from "@/pages/DemandPlanningPage";
import CRMBoardPage from "@/pages/crm/CRMBoardPage";
import CRMParty360Page from "@/pages/crm/CRMParty360Page";
import CRMMyWorkPage from "@/pages/crm/CRMMyWorkPage";
import CRMAdminPage from "@/pages/crm/CRMAdminPage";
import CRMExceptionsPage from "@/pages/crm/CRMExceptionsPage";
import DPPipelinePage from "@/pages/dp/DPPipelinePage";
import DPApplicationPage from "@/pages/dp/DPApplicationPage";
import DPDetailPage from "@/pages/dp/DPDetailPage";
import DPBrandsPage from "@/pages/dp/DPBrandsPage";
import DPPincodeSearchPage from "@/pages/dp/DPPincodeSearchPage";
import DPTerritoryApprovalsPage from "@/pages/dp/DPTerritoryApprovalsPage";
import LeadDeskPage from "@/pages/leads/LeadDeskPage";
import LeadQuickAdd from "@/pages/leads/LeadQuickAdd";
import LeadDetailPage from "@/pages/leads/LeadDetailPage";
import LeadImportPage from "@/pages/leads/LeadImportPage";
import CampaignReportPage from "@/pages/leads/CampaignReportPage";
import BrandsListPage from "@/pages/brands/BrandsListPage";
import BrandFormPage from "@/pages/brands/BrandFormPage";
import BrandDetailPage from "@/pages/brands/BrandDetailPage";
import BrandApprovalsPage from "@/pages/brands/BrandApprovalsPage";
import BrandProductsPage from "@/pages/brands/BrandProductsPage";
import CheckRestrictionPage from "@/pages/brands/CheckRestrictionPage";
import UnlinkedProductsPage from "@/pages/brands/UnlinkedProductsPage";
import PulseAnalyticsPage from "@/pages/PulseAnalyticsPage";
import OpsItemsPage from "@/pages/ops/OpsItemsPage";
import OpsVendorsPage from "@/pages/ops/OpsVendorsPage";
import OpsLocationsPage from "@/pages/ops/OpsLocationsPage";
import OpsBomPage from "@/pages/ops/OpsBomPage";
import OpsConfigPage from "@/pages/ops/OpsConfigPage";
import OpsIndentsPage from "@/pages/ops/OpsIndentsPage";
import OpsPurchaseOrdersPage from "@/pages/ops/OpsPurchaseOrdersPage";
import OpsGatePassPage from "@/pages/ops/OpsGatePassPage";
import OpsGrnPage from "@/pages/ops/OpsGrnPage";
import OpsVendorInvoicesPage from "@/pages/ops/OpsVendorInvoicesPage";
import OpsPaymentRequisitionsPage from "@/pages/ops/OpsPaymentRequisitionsPage";
import OpsVendorOutstandingPage from "@/pages/ops/OpsVendorOutstandingPage";
import OpsEcomStockPage from "@/pages/ops/OpsEcomStockPage";
import OpsOpeningStockPage from "@/pages/ops/OpsOpeningStockPage";
import OpsPackingPage from "@/pages/ops/OpsPackingPage";
import OpsStockDashboardPage from "@/pages/ops/OpsStockDashboardPage";
import OpsReturnsInwardPage from "@/pages/ops/OpsReturnsInwardPage";
import OpsStockAdjustmentsPage from "@/pages/ops/OpsStockAdjustmentsPage";
import OpsStockTransfersPage from "@/pages/ops/OpsStockTransfersPage";
import ClaimsListPage from "@/pages/claims/ClaimsListPage";
import NewClaimPage from "@/pages/claims/NewClaimPage";
import ClaimDetailPage from "@/pages/claims/ClaimDetailPage";
import AllDecisionsPage from "@/pages/claims/AllDecisionsPage";
import RecoveriesPage from "@/pages/claims/RecoveriesPage";
import ClaimsSettingsPage from "@/pages/claims/ClaimsSettingsPage";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="flex items-center justify-center min-h-screen" data-testid="loading-screen">
      <div className="text-zinc-500 text-sm">Loading...</div>
    </div>
  );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="flex items-center justify-center min-h-screen" data-testid="loading-screen">
      <div className="text-zinc-500 text-sm">Loading...</div>
    </div>
  );

  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <LoginPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/pulse/analytics" element={<ProtectedRoute><PulseAnalyticsPage /></ProtectedRoute>} />
      <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route index element={<DashboardPage />} />
        <Route path="profile" element={<ProfilePage />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="roles" element={<RolesPage />} />
        <Route path="teams" element={<TeamsPage />} />
        <Route path="channels" element={<ChannelsPage />} />
        <Route path="customers" element={<CustomersPage />} />
        <Route path="orders" element={<OrdersPage />} />
        <Route path="orders/new" element={<CreateOrderPage />} />
        <Route path="orders/:orderId" element={<OrderDetailPage />} />
        <Route path="skus" element={<SKUsPage />} />
        <Route path="catalogue" element={<CataloguePage />} />
        <Route path="catalogue/approvals" element={<CatalogueApprovalsPage />} />
        <Route path="external-ship-orders" element={<ExternalShipOrdersPage />} />
        <Route path="admin/categories" element={<AdminCategoriesPage />} />
        <Route path="admin/customer-types" element={<AdminCustomerTypesPage />} />
        <Route path="admin/settings" element={<AdminSettingsPage />} />
        <Route path="admin/data-scripts" element={<DataScriptsPage />} />
        <Route path="reports" element={<ReportsPage />} />
        <Route path="warehouses" element={<WarehousesPage />} />
        <Route path="inventory" element={<InventoryPage />} />
        <Route path="admin/security" element={<SecurityDashboardPage />} />
        <Route path="ss-inventory" element={<SSInventoryPage />} />
        <Route path="ss-inventory/opening-stock" element={<SSOpeningStockPage />} />
        <Route path="ss-inventory/record-delivery" element={<SSRecordDeliveryPage />} />
        <Route path="ss-inventory/record-outflow" element={<SSRecordOutflowPage />} />
        <Route path="ss-inventory/reset" element={<SSResetStockPage />} />
        <Route path="ss-facility-mapping" element={<SSFacilityMappingPage />} />
        <Route path="platform-sku-mapping" element={<PlatformSkuMappingPage />} />
        <Route path="ss-in-transit" element={<SSInTransitPage />} />
        <Route path="returns" element={<RTOListPage />} />
        <Route path="returns/:rtoId" element={<RTODetailPage />} />
        <Route path="proforma-invoices" element={<ProformaInvoicesPage />} />
        <Route path="rto-stock" element={<RTOStockPage />} />
        <Route path="damaged-stock" element={<DamagedStockPage />} />
        <Route path="credit-notes" element={<CreditNotesPage />} />
        <Route path="po-inbox" element={<POInboxPage />} />
        <Route path="qcom-health" element={<QcomHealthPage />} />
        <Route path="reports/qcom-sla-performance" element={<QcomSLAPerformancePage />} />
        <Route path="sales-targets" element={<SalesTargetsPage />} />
        <Route path="reports/pnl-audit" element={<PnLAuditPage />} />
        <Route path="reports/stock-on-hold" element={<StockOnHoldPage />} />
        <Route path="qcom-ss/:ssId" element={<QcomSSDetailPage />} />
        <Route path="reports/blinkit-checks" element={<BlinkitChecksPage />} />
        <Route path="platform-invoices" element={<PlatformInvoicesPage />} />
        <Route path="sor-accounts" element={<SorAccountsPage />} />
        <Route path="refunds" element={<RefundsPage />} />
        <Route path="reports/pod" element={<PODReportPage />} />
        <Route path="reports/receivables" element={<ReceivablesPage />} />
        <Route path="logistics/upload-freight" element={<FreightUploadPage />} />
        {/* ORBIT Pulse */}
        <Route path="pulse" element={<PulsePage />} />
        <Route path="demand-planning" element={<DemandPlanningPage />} />
        <Route path="admin/migrate-invoice-dates" element={<MigrateInvoiceDatesPage />} />
        <Route path="admin/channel-backfill" element={<ChannelBackfillPage />} />
        <Route path="admin/data-quality" element={<DataQualityPage />} />
        {/* ORBIT OPS */}
        <Route path="ops/items" element={<OpsItemsPage />} />
        <Route path="ops/vendors" element={<OpsVendorsPage />} />
        <Route path="ops/locations" element={<OpsLocationsPage />} />
        <Route path="ops/bom" element={<OpsBomPage />} />
        <Route path="ops/settings/config" element={<OpsConfigPage />} />
        <Route path="ops/indents" element={<OpsIndentsPage />} />
        <Route path="ops/purchase-orders" element={<OpsPurchaseOrdersPage />} />
        <Route path="ops/gate-passes" element={<OpsGatePassPage />} />
        <Route path="ops/grn" element={<OpsGrnPage />} />
        <Route path="ops/vendor-invoices" element={<OpsVendorInvoicesPage />} />
        <Route path="ops/payment-requisitions" element={<OpsPaymentRequisitionsPage />} />
        <Route path="ops/vendor-outstanding" element={<OpsVendorOutstandingPage />} />
        <Route path="ops/ecom-stock" element={<OpsEcomStockPage />} />
        <Route path="ops/stock" element={<OpsStockDashboardPage />} />
        <Route path="ops/opening-stock" element={<OpsOpeningStockPage />} />
        <Route path="ops/packing" element={<OpsPackingPage />} />
        <Route path="ops/returns-inward" element={<OpsReturnsInwardPage />} />
        <Route path="ops/stock-adjustments" element={<OpsStockAdjustmentsPage />} />
        <Route path="ops/stock-transfers" element={<OpsStockTransfersPage />} />
        <Route path="crm" element={<CRMBoardPage />} />
        <Route path="crm/party/:partyId" element={<CRMParty360Page />} />
        <Route path="crm/my-work" element={<CRMMyWorkPage />} />
        <Route path="crm/admin" element={<CRMAdminPage />} />
        <Route path="crm/exceptions" element={<CRMExceptionsPage />} />
        <Route path="dp" element={<DPPipelinePage />} />
        <Route path="dp/apply" element={<DPApplicationPage />} />
        <Route path="dp/partner/:profileId" element={<DPDetailPage />} />
        <Route path="dp/brands" element={<DPBrandsPage />} />
        <Route path="dp/search" element={<DPPincodeSearchPage />} />
        <Route path="dp/approvals" element={<DPTerritoryApprovalsPage />} />
        <Route path="leads" element={<LeadDeskPage />} />
        <Route path="leads/new" element={<LeadQuickAdd />} />
        <Route path="leads/import" element={<LeadImportPage />} />
        <Route path="leads/campaign-report" element={<CampaignReportPage />} />
        <Route path="leads/:leadId" element={<LeadDetailPage />} />
        <Route path="brands" element={<BrandsListPage />} />
        <Route path="brands/new" element={<BrandFormPage />} />
        <Route path="brands/approvals" element={<BrandApprovalsPage />} />
        <Route path="brands/check" element={<CheckRestrictionPage />} />
        <Route path="brands/unlinked-products" element={<UnlinkedProductsPage />} />
        <Route path="brands/:brandId" element={<BrandDetailPage />} />
        <Route path="brands/:brandId/edit" element={<BrandFormPage />} />
        <Route path="brands/:brandId/products" element={<BrandProductsPage />} />
        {/* Claims Desk (CL1) — API is flag-gated; nav hidden while CLAIMS is off */}
        <Route path="claims" element={<ClaimsListPage />} />
        <Route path="claims/new" element={<NewClaimPage />} />
        <Route path="claims/decisions" element={<AllDecisionsPage />} />
        <Route path="claims/recoveries" element={<RecoveriesPage />} />
        <Route path="claims/settings" element={<ClaimsSettingsPage />} />
        <Route path="claims/:claimId" element={<ClaimDetailPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-right" richColors />
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
